import React from 'react'
import { asArray } from 'lib/utilities'

const InputItems = ({items}) => {
  items = asArray(items)
  if (items.length == 0)
    return null

  return <div className="pended-item-container">{items}</div>
}

const Input = (props) => {
  const { id, name, required, label, classes, placeholder, onKeyDown, onKeyUp, onFocus, onBlur, onChange, value, prepend, append, type='text', readOnly} = props

  return (
    <div className={`input-label-group ${classes ?? ''}`}>
      <div className="dome-d-flex dome-justify-between">
        {label && (
          <label htmlFor={id} className="dome-p3 dome-color-med-grey">
            {label}
          </label>
        )}
        {required && (
          <div className="dome-d-flex dome-align-center dome-gap3">
            <i className="fa-light fa-circle-exclamation dome-color-red-alert"></i>
            <span className="dome-p3 dome-color-red-alert">required</span>
          </div>
        )}
      </div>
      <div className="inputs input-rounded" style={{ background: readOnly ? '#f0f0f0' : 'white' }}>
        <InputItems items={prepend} />
        <input style={{ background: readOnly ? '#f0f0f0' : 'white' }} readOnly={readOnly} id={id} name={name} type={type} value={value} onChange={onChange} onFocus={onFocus} onKeyDown={onKeyDown} onKeyUp={onKeyUp} onBlur={onBlur} placeholder={placeholder} />
        <InputItems items={append} />
      </div>
    </div>
  )
}

export default Input
//
